
















export default {
  name: 'epb-link',
  props: {
    color: {
      type: String,
      default: 'primary'
    },
    icon: String,
    iconPosition: { // left, right
      type: String,
      default: 'left'
    },
    iconSize: { // small, regular, big
      type: String,
      default: 'regular'
    },
    underlined: Boolean,
    disabled: Boolean
  }
};
